import { useRouter } from 'expo-router'
import { memo, type ReactNode } from 'react'

import { Card } from '@/src/elements/card/Card'
import { TEST_ID } from '@/src/general/constants/testId'
import { getImageUrl } from '@/src/general/utils/getImageUrl'
import { useRoutes } from '@/src/general/utils/routes'

import { EVENT_ORIGIN } from '../../../models/community.constants'
import { CommunityThumbnail } from '../../components/CommunityThumbnail'
import type { TCommunitySubscriptionCardProps } from './CommunitySubscriptionCard.types'
import { CommunitySubscriptionCardMessage } from './CommunitySubscriptionCardMessage'

export const CommunitySubscriptionCard = memo(({ communityFeedItem }: TCommunitySubscriptionCardProps): ReactNode => {
  const router = useRouter()
  const { routes } = useRoutes()

  const { community } = communityFeedItem

  return (
    <Card
      testID={`${TEST_ID.COMMUNITY.SUBSCRIPTION_CARD}-${community.id}`}
      className="flex-column flex gap-4 rounded-xl bg-default-bg-white p-4"
      onPress={() =>
        router.navigate(
          routes.community({ id: community.id, slug: community.slug, origin: EVENT_ORIGIN.SUBSCRIPTION_CARD }),
        )
      }
      isPressable
    >
      <CommunityThumbnail
        title={communityFeedItem.community.name}
        titleProps={{ bold: true, size: 'md' }}
        imgSource={communityFeedItem.community.picture && getImageUrl(communityFeedItem.community.picture)}
        imageTestID={TEST_ID.COMMUNITY.PICTURE}
        showImage
        centered
      />
      <CommunitySubscriptionCardMessage communityFeedItem={communityFeedItem} />
    </Card>
  )
})
